import { useRouter } from "next/router";
import Link from "next/link";
import { useTranslation } from "next-i18next";
import { Column, ProductsItem } from "styles/jss/ProductsPage.styles";
import { StandardImageWrapper } from "styles/jss/Layout.styles";
import NextImage from "../../NextImage";
import { getImageUrl } from "utils/helperFunction";
import { Grid } from "@mui/material";

const ProductItem = ({ id, attributes }) => {
  const { t } = useTranslation(["products"]);
  const { locale } = useRouter();
  const { images, name, slug, density, mfi, applications, type } = attributes;

  return (
    <Link
      href={`/products/${type.data.attributes.name
        .toString()
        .toLowerCase()
        .split(" ")
        .join("-")}/${slug}`}
      locale={locale}
    >
      <a>
        <ProductsItem>
          <Grid container rowSpacing={{ xs: 2 }}>
            <Grid item xs={12} md={3}>
              <Column className={"typeColumn"}>
                <StandardImageWrapper className={"imageWrapper"}>
                  <NextImage
                    src={
                      getImageUrl(
                        images.data[0].attributes.formats,
                        "thumbnail",
                      )?.url
                    }
                    layout={"fill"}
                    objectFit={"cover"}
                    placeholder="blur"
                    alt={name}
                  />
                </StandardImageWrapper>
                <Column locale={locale}>
                  <h3 className={"title"}>{t("type")}</h3>
                  <p className={"text"}>{name}</p>
                </Column>
              </Column>
            </Grid>
            <Grid item xs={12} md={2}>
              <Column locale={locale}>
                <h3 className={"title"}>{t("mfi")}</h3>
                <p className={"text"}>{mfi}</p>
              </Column>
            </Grid>
            <Grid item xs={12} md={2}>
              <Column>
                <h3 className={"title"}>{t("density")}</h3>
                <p className={"text"}>{density}</p>
              </Column>
            </Grid>
            <Grid item xs={12} md={5}>
              <Column locale={locale}>
                <h3 className={"title"}>{t("application")}</h3>
                <p className={"text app"}>
                  {applications?.data
                    .map(item => item.attributes.application)
                    .join(", ")}
                </p>
              </Column>
            </Grid>
          </Grid>
        </ProductsItem>
      </a>
    </Link>
  );
};

export default ProductItem;
